<template>
  <div id="app">
    <!-- NavBar -->
    <NavBar v-if="$route.meta.showNav == 'hide' ? false : true" />
    <!-- Routes -->
    <router-view
      :style="$route.meta.showNav == 'sub' || $route.meta.showNav == 'hide'
        ? 'margin-top: 0rem'
        : 'margin-top: 4rem'
      "
     />
    <!-- Footer -->
    <Footer v-if="$route.meta.showFooter == 'hide' ? false : true" />
  </div>
</template>

<script>
// Global Components
const NavBar = () => import('@/components/NavBar')
const Footer = () => import('@/components/Footer')

export default {
  name: 'App',
  components: {
    NavBar,
    Footer
  },
  mounted () {
    if (process.env.VUE_APP_INFOCRATICS_INTEGRARION) {
      console.log('<=== Infocratics ON ===>')
      let infocraticsScript = document.createElement('script')
      infocraticsScript.innerHTML = `
          !function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var t=analytics.methods[e];analytics[t]=analytics.factory(t)}analytics.load=function(e,t){var n=document.createElement("script");n.type="text/javascript";n.async=!0;n.src="https://cdn.segment.com/analytics.js/v1/"+e+"/analytics.min.js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(n,a);analytics._loadOptions=t};analytics.SNIPPET_VERSION="4.1.0";
          analytics.load("SL8BmTcFA3bpxgfTbD3GXDt8k8k1WtW2");
          analytics.page();
          }}();
      `
      document.head.appendChild(infocraticsScript)
    }
  }
}
</script>

<style lang="scss">
@import 'node_modules/bootstrap/scss/bootstrap';
@import 'node_modules/bootstrap-vue/src/index.scss';
@import url('https://fonts.googleapis.com/css?family=Poppins');

#app {
  font-family: 'Poppins', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

}

$blue: #283E99;
$green: #009CB4;

h2 {
  font-weight: 600
}

.userLogged {
  .nav-link {
    color: #424242 !important
  }
}

// Filter Mobile / Tablet
#filter {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background-color: white;
  overflow: scroll;

  .header {
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    background-color: $blue !important;

    .btnClose {
      padding-left: 0 !important;
      border-color: transparent !important;
      background-color: transparent !important;
      color: white !important;

      svg {
        margin-top: -2px;

        path {
          fill: white !important;
        }
      }
    }
  }
}

#favorite {
  .btn-link {
    img {
      height: 15rem
    }
  }
}

.userLoggedSub {
  .nav-link {
    color: white !important
  }
}

.userLoggedScrolled {
  .nav-link {
    color: #424242 !important
  }
}

.text-primary {
  color: $blue !important;
}

.color-red {
  color: red
}

.color-blue {
  color: $blue !important
}

.nav-link {
  color: #424242 !important
}

.bg-blue {
  background-color: $blue !important;
  color: white !important;
}

.color-green {
  color: $green !important
}

.bg-green {
  background-color: $green !important;
  color: white !important;
}

// NavBar
.icon {
  width: 2rem;
  height: 2.3rem !important;
}

.logo {
  width: 5.5rem;
}

.navbar-nav .dropdown-menu {
  position: absolute;
  box-shadow: 0 4px 10px -2px grey;
  width: 280px !important;
  height: auto !important;
}

.dropdown-item.active, .dropdown-item:active {
  background-color: $blue !important;
}

:focus {
  outline: none !important
}

// Fonts and sizes

p {
  color: rgba(0, 0, 0, 0.54);
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 20px;
}

label {
  font-size: 14px;
}

input {
  font-family: "Poppins", sans-serif !important;
}

.btn-link {
  color: $blue;
  text-decoration: none !important;
}

.btn-link:hover {
  color: $blue;
}

strong {
  color: #222;
}

// Buttons
.btn-primary {
  color: white !important;
  background-color: $blue !important;
  border-color: $blue !important;

  path {
    fill: white !important;
  }
}

.btn-primary:hover {
  color: white !important;
  background-color: $blue !important;
}

.btn-primary:focus {
  box-shadow: none !important;
}

.btn-secondary {
  color: white !important;
  background-color: $green !important;
  border-color: $green !important
}

.btn-secondary:hover {
  color: white !important;
  background-color: $green !important;
}

.btn-secondary:focus {
  box-shadow: none !important;
}

.btn-outline-primary {
  color: $blue !important;
  border-color: $blue !important;
  fill: $blue !important
}

.btn-outline-primary:hover {
  color: white !important;
  background-color: $blue !important;

  svg {
    fill: white !important;
  }
}

.btn-outline-primary:focus {
  box-shadow: none !important;
}

.btn-outline-secondary {
  color: $green;
  border-color: $green
}

.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {
  background-color: $blue;
  color: white !important;

  path {
    fill: white !important
  }
}

.btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active, .show > .btn-outline-light.dropdown-toggle {
  background-color: transparent !important;
}

.btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-light.dropdown-toggle:focus {
  box-shadow: none !important;
}

// Custom
a:hover {
  color: transparent;
  text-decoration: none;
}
.section {
  margin: 10rem 0
}

.menu {
  .dropdown-toggle::after {
    display: none !important;
  }
}

#enter {
  .form-control {
    outline: 0;
    border-width: 0 0 2px !important;
    border-radius: 0rem !important;
    padding: 0 !important;
  }

  #confirmCode {
    .form-control {
      text-align: center;
    }
  }
}

#modalImages {
  .modal-dialog {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0;
    max-width: 100%;

    .modal-content {
      border: none;
      height: 100vh;
    }
  }

  .btnCloseModalImages {
    z-index: 999
  }
}

.custom-select:focus {
  border-color: $blue !important;
  box-shadow: none !important;
}

.form-control:focus {
  border-color: $blue !important;
  box-shadow: none !important;
}

.btn-outline-primary:focus,
.btn-outline-primary.focus {
  box-shadow: none !important;
}

//Pagination
.page-link {
  color: $blue !important;
}

.page-item.active .page-link {
  color: white !important;
  background-color: $blue !important;
  border-color: $blue !important;
}

.page-link:focus {
  box-shadow: none !important;
}

.card-carousel .card .card-header img {
  height: 15rem
}

@media(min-width: 320px) and (max-width: 1000px) {
  .card-scroll .card .card-header img {
    height: 16rem
  }

  #opportunities .card .card-header img {
    height: 20rem
  }
}

@media(min-width: 1024px) and (max-width: 1920px) {
  #opportunities .card .card-header img {
    height: 18rem
  }
}
</style>
